import { Link } from "react-router-dom";
import { ArrowRight, Check, Phone } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { Pricing } from "@/components/Pricing";
import { Seo } from "@/components/Seo";
import { PAGE_SEO } from "@/data/seo";

const TRUCKS = [
  { name: "Small Truck (3 Tonne)", rate: "$69/hr", best: "Studio & 1-bedroom moves", img: "/images/truck-small.png" },
  { name: "Medium Truck (4.5–6 Tonne)", rate: "$89/hr", best: "2–3 bedroom homes", img: "/images/truck-medium.png" },
  { name: "Large Truck (8–10 Tonne)", rate: "$109/hr", best: "4+ bedroom & office moves", img: "/images/truck-large.png" },
];

export default function PricingPage() {
  return (
    <main className="min-h-screen" data-testid="pricing-page-main">
      <Seo {...PAGE_SEO.pricing} />
      <Header />
      <h1 className="sr-only">Removalist Pricing Melbourne — Truck & Mover Hourly Rates | MoversNearby</h1>
      <div className="pt-32 lg:pt-36" data-testid="pricing-page">
        <Pricing />
        <section className="mx-auto max-w-7xl px-5 py-20 lg:px-10" data-testid="pricing-trucks">
          <Reveal>
            <h2 className="font-display text-3xl font-semibold uppercase tracking-tighter text-slate-900 sm:text-4xl">
              Truck rates — every truck includes 1 professional mover &amp; tail lift
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {TRUCKS.map((t, i) => (
              <Reveal key={t.name} delay={i * 0.1}>
                <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-shadow hover:shadow-lg" data-testid={`pricing-truck-${i}`}>
                  <div className="h-44 bg-slate-50">
                    <img src={t.img} alt={t.name} className="h-full w-full object-cover" loading="lazy" />
                  </div>
                  <div className="p-6">
                    <p className="font-display text-lg font-semibold text-slate-900">{t.name}</p>
                    <p className="mt-1 font-display text-3xl font-semibold text-blaze">{t.rate}</p>
                    <p className="mt-2 flex items-center gap-2 text-sm text-slate-600">
                      <Check className="h-4 w-4 text-blue-600" /> Best for: {t.best}
                    </p>
                    <p className="mt-1 flex items-center gap-2 text-xs text-slate-500">
                      <Check className="h-4 w-4 text-blue-600" /> Includes 1 professional mover + tail lift
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-14 flex flex-wrap items-center justify-center gap-4 text-center">
              <Link
                to="/#quote"
                data-testid="pricing-page-quote-btn"
                className="group flex items-center gap-3 rounded-lg bg-blaze px-8 py-4 text-sm font-bold uppercase tracking-wider text-white transition-all duration-300 hover:scale-[1.04] hover:bg-blue-700"
              >
                Get a Quote
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <a href="tel:0391136005" className="flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-blaze">
                <Phone className="h-4 w-4 text-blaze" /> Prefer to talk? 03 9113 6005
              </a>
            </div>
          </Reveal>
        </section>
      </div>
      <Footer />
    </main>
  );
}
